import { PageId } from '../enum/PageId';
import { getPageId } from '../utils';

export function usePages() {
  const pageId = getPageId();

  const publicPages: string[] = [
    PageId.ForgotPassword,
    PageId.ForgotPasswordSuccess,
    PageId.ForgotPasswordSubmission,
    PageId.ForgotPasswordSubmissionSuccess,
    PageId.ForgotUsername,
    PageId.ForgotUsernameSuccess,
    PageId.Login,
  ];
  const isPublicPage = publicPages.includes(pageId);

  const errorPages: string[] = [PageId.Forbidden, PageId.Suspended, PageId.NotFound, PageId.Error];
  const isErrorPage = errorPages.includes(pageId);

  return {
    pageId,
    isPublicPage,
    isErrorPage,
  };
}
